import { render } from "./ThinkTankModal.vue?vue&type=template&id=0d1ab1df"
import script from "./ThinkTankModal.vue?vue&type=script&lang=js"
export * from "./ThinkTankModal.vue?vue&type=script&lang=js"
script.render = render

export default script